export const iconFontAwesomeReligionAnkh = (
	<i className="fa-solid fa-ankh"></i>
);
